export class Monad<T, E = string> {
    private constructor(
        private state: "idle" | "loading" | "success" | "error",
        private data?: T,
        private error?: E
    ) { }

    static idle<T, E = string>(): Monad<T, E> {
        return new Monad<T, E>("idle");
    }

    static loading<T, E = string>(): Monad<T, E> {
        return new Monad<T, E>("loading");
    }

    static success<T, E = string>(data: T): Monad<T, E> {
        return new Monad<T, E>("success", data);
    }

    static error<T, E = string>(error: E): Monad<T, E> {
        return new Monad<T, E>("error", undefined, error);
    }

    map<U>(fn: (data: T) => U): Monad<U, E> {
        return this.state === "success"
            ? Monad.success<U, E>(fn(this.data!))
            : (this as unknown as Monad<U, E>);
    }

    getOrElse(defaultValue: T): T {
        return this.state === "success" ? this.data! : defaultValue;
    }

    match<R>(cases: {
        idle?: () => R;
        loading?: () => R;
        success?: (data: T) => R;
        error?: (error: E) => R;
    }): R | null {
        switch (this.state) {
            case "idle":
                return cases.idle ? cases.idle() : null;
            case "loading":
                return cases.loading ? cases.loading() : null;
            case "success":
                return cases.success ? cases.success(this.data!) : null;
            case "error":
                return cases.error ? cases.error(this.error!) : null;
        }
    }
}